import React, { useCallback, useMemo } from 'react';

import {
  Table,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableBody,
  Text,
  Skeleton,
} from '@razorpay/blade/components';

import { AssignedFlexibleComponentsTableDataType } from '../../types';
import { AllocateFBPTableRow } from './AllocateFBPTableRow';

export const FBPAllocationTable = ({
  flexibleData,
  setSelectedRows,
  monthlyDeclaration,
  onChange,
  isFetching,
  isLoading,
  selectedRows,
  monthlyDeclarationErrors,
  isAdmin,
}: {
  flexibleData?: AssignedFlexibleComponentsTableDataType[];
  setSelectedRows: (selectedRows: string[]) => void;
  monthlyDeclaration: Record<string, string>;
  onChange: ({ id, value }: { id: string; value: string }) => void;
  isFetching: boolean;
  isLoading: boolean;
  selectedRows: string[];
  monthlyDeclarationErrors: Record<string, string>;
  isAdmin: boolean;
}) => {
  const handleSelectionChange = useCallback(
    ({ selectedIds }: { selectedIds: (string | number)[] }) => {
      const ids = selectedIds.map((id) => id.toString());
      setSelectedRows(ids);
    },
    [],
  );

  const tableData = flexibleData ?? [];

  return (
    <>
      {isLoading ? (
        <Skeleton
          width={'100%'}
          height={'400px'}
          borderRadius="medium"
          marginTop={'spacing.7'}
          testID="FBP-loading-table"
        />
      ) : (
        <Table
          showBorderedCells={true}
          selectionType={isAdmin ? 'multiple' : 'none'}
          defaultSelectedIds={selectedRows}
          data={{ nodes: tableData }}
          display="grid"
          gridTemplateColumns={isAdmin ? '0.25fr 3fr 2fr 2fr 2.5fr 2fr' : '3fr 1.5fr 2fr 2.5fr 2fr'}
          rowDensity="normal"
          marginTop={'spacing.7'}
          isRefreshing={isFetching}
          multiSelectTrigger="checkbox"
          onSelectionChange={handleSelectionChange}>
          {(tableData) => (
            <>
              <TableHeader>
                <TableHeaderRow>
                  <TableHeaderCell>
                    <Text weight="semibold"> Flexible component </Text>
                  </TableHeaderCell>
                  <TableHeaderCell>
                    <Text weight="semibold"> Tax Exemption </Text>
                  </TableHeaderCell>
                  <TableHeaderCell>
                    <Text weight="semibold"> Max. limit per month </Text>
                  </TableHeaderCell>
                  <TableHeaderCell>
                    <Text weight="semibold">Monthly declaration </Text>
                  </TableHeaderCell>
                  <TableHeaderCell>
                    <Text weight="semibold">Yearly amount </Text>
                  </TableHeaderCell>
                </TableHeaderRow>
              </TableHeader>

              <TableBody>
                {tableData.map((rowData) => (
                  <AllocateFBPTableRow
                    key={rowData.id}
                    rowData={rowData}
                    monthlyDeclarationValue={monthlyDeclaration[rowData.id] || ''}
                    onChange={onChange}
                    monthlyDeclarationErrors={monthlyDeclarationErrors}
                    isAdmin={isAdmin}
                  />
                ))}
              </TableBody>
            </>
          )}
        </Table>
      )}
    </>
  );
};
